<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {mapActions, mapGetters} from "vuex";

export default {
  page: {
    title: "Message Logs",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      category: this.$route.params.category,
      title: "Message Logs",
      items: [
        {
          text: "Message Logs",
          href: "/",
        },
        {
          text: "Message Logs",
          active: true,
        },
      ],
    };
  },
    computed: {
        ...mapGetters("messages", ["SentMessages"]),
    },
    methods: {
        ...mapActions({
            FetchSentMessages: "messages/fetchSentMessages",
        }),
    },
    created() {
        this.FetchSentMessages(this.category);
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- Collapse -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title text-uppercase text-primary mb-3">Messages Sent Under {{ category }}</h3>
              <b-card class="border-bottom border-dark shadow-lg" v-for="(message, m) in SentMessages" :key="m">
                  <b-card-title>Receiver: +256{{ message.receiver }}</b-card-title>
                  <b-card-text>
                      <p>No. of Messages: {{ message.size}} sms</p>
                      <p>Body: <em><b>{{ message.body }}</b></em></p>
                  </b-card-text>
                  <b-card-text class="small text-muted">Sent on {{ message.date }} - <b>{{ message.time }}</b> </b-card-text>
              </b-card>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
